<template>
  <div>
    <b-tabs>
      <b-tab class="tab-margin" title="関税登録">
        <custom-registration/>
      </b-tab>
      <b-tab v-on:click="doActive" class="tab-margin" title="関税一覧参照">
        <custom-refarence :version="version" :isUpdate="isUpdate" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseView from '@/views/BaseView';
import CustomRefarence from '@/components/custom/CustomReference';
import CustomRegistration from '@/components/custom/CustomRegistration';

export default {
  mixins: [BaseView],
  data() {
    return {
      deposit: 0,
      requireDeposit: 0,
      isWarnDeposit: false,
      version: 1,
      isUpdate: false
    }
  },
  created() { this.updateTitle('関税'); },
  methods: {
    doActive(){
      this.version = this.version + 1;
      this.isUpdate = true;
    },
  },
};

Vue.component('custom-refarence', CustomRefarence);
Vue.component('custom-registration', CustomRegistration);
</script>

<style>
.tab-margin {
  margin-top: 1rem;
}
</style>
